import React from "react";
import styles from "./LatestDrops.module.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import categoryContent from "../../../json/categoryContent.json";

const LatestDrops = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const categorySlug = searchParams.get("category");
  const sectionSlug = searchParams.get("section");

  const items = (categoryContent[categorySlug]?.items || []).slice(0, 6);

  if (!items.length) return null;

  const handleClick = (item) => {
    if (item.url) {
      // External links open in a new tab; internal (relative) links navigate
      // within the app so their page/data actually shows.
      if (/^https?:\/\//i.test(item.url)) {
        window.open(item.url, "_blank", "noopener,noreferrer");
      } else {
        navigate("/" + item.url.replace(/^\/+/, "").replace(/\/+$/, ""));
      }
    } else {
      navigate(`/blog-detail?section=${sectionSlug}&category=${categorySlug}`);
    }
  };

  return (
    <>
      <section className={styles.wrapper}>
        <div className={styles.container}>
          <h2 className={styles.heading}>Latest Drops</h2>

          <div className={styles.grid}>
            {items.map((item) => (
              <div
                key={item.id}
                className={styles.card}
                onClick={() => handleClick(item)}
              >
                <div className={styles.imageWrapper}>
                  <img src={item.image} alt={item.title} className={styles.image} loading="lazy" decoding="async" />
                </div>

                <h3 className={styles.cardTitle}>{item.title}</h3>
                {item.date && <p className={styles.cardDate}>{item.date}</p>}
                <p className={styles.title}>{item.description}</p>

                <button className={styles.readMore}>
                  Read more
                  <img src="/svg/arrow_new.svg" alt="arrow_new" loading="lazy" decoding="async" />
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default LatestDrops;
